import { render, staticRenderFns } from "./ArchivedChats.vue?vue&type=template&id=4dd3a620&"
import script from "./ArchivedChats.vue?vue&type=script&lang=js&"
export * from "./ArchivedChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports